module.exports = __webpack_public_path__ + "static/fonts/Nunito-Italic.292a836.woff";